<template>
  <b-row>
    <StepperCol :step="13" />
    <b-col cols="10" md="11" class="pb-4">
      <h5
        class="h3 font-weight-normal mb-4"
        :class="collapsed ? '' : 'text-muted'"
      >
        室外機を設置する階は？
      </h5>
      <b-collapse v-model="shrinking" class="d-md-none">
        <b-button
          variant="outline-warning"
          size="lg"
          class="btn-gd text-left position-relative py-2"
          block
          @click="shrinking = false"
        >
          <span class="h4 m-0">{{ selectedTitle }}</span>
          <div class="d-block text-muted">
            ¥{{ selectedPrice.toLocaleString() }}
            {{ selectedPrice === 0 ? "-" : "~" }}
          </div>
          <div class="accessory-shrinking">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 12 12"
            >
              <polyline
                fill="none"
                stroke="#FD9000"
                stroke-width="2"
                points="0,6 6,11 12,6"
              />
            </svg>
          </div>
        </b-button>
      </b-collapse>
      <h5 v-if="skipped" class="text-muted">回答はご無用です</h5>
      <template v-else>
        <b-collapse v-model="isCollapsed">
          <b-row>
            <b-col v-if="unitType === 6 || unitType === 7" cols="12" md="6" lg="5" class="mb-3">
              <b-button
                class="btn-gd text-left p-0 h-145px"
                :class="selectedAnswer == 1 ? 'selected' : ''"
                @click="buttonClicked(1)"
              >
                <div class="p-3">
                    <h6 class="h4 mb-0">1階部分の屋根に<br />取り付ける</h6>
                    <dl class="text-muted mb-0">
                      <dt>追加工事<br />高所作業費</dt>
                      <dd class="font-weight-bold h5 mb-0">
                        ¥<span class="h3 ml-1">11,000-</span>
                      </dd>
                    </dl>
                  </div>
              </b-button>
            </b-col>
            <b-col v-if="unitType === 6 || unitType === 7" cols="12" md="6" lg="5" class="mb-3">
              <b-button
                class="btn-gd text-left p-0 h-145px"
                :class="selectedAnswer == 2 ? 'selected' : ''"
                @click="buttonClicked(2)"
              >
                <div class="p-3">
                    <h6 class="h4 mb-0">2階部分の屋根に<br />取り付ける</h6>
                    <dl class="text-muted mb-0">
                      <dt>追加工事<br />高所作業費</dt>
                      <dd class="font-weight-bold h5 mb-0">
                        ¥<span class="h3 ml-1">27,500-</span>
                      </dd>
                    </dl>
                  </div>
              </b-button>
            </b-col>
            <b-col v-if="unitType === 2 || unitType === 3" cols="12" md="6" lg="5" class="mb-3">
              <b-button
                class="btn-gd text-left p-0 h-145px"
                :class="selectedAnswer == 3 ? 'selected' : ''"
                @click="buttonClicked(3)"
              >
                <div class="p-3">
                    <h6 class="h4 mb-0">1階の壁面に<br />取り付ける</h6>
                    <dl class="text-muted mb-0">
                      <dt>追加工事<br />高所作業費</dt>
                      <dd class="font-weight-bold h5 mb-0">
                        ¥<span class="h3 ml-1">0-</span>
                      </dd>
                    </dl>
                  </div>
              </b-button>
            </b-col>
            <b-col v-if="unitType === 2 || unitType === 3" cols="12" md="6" lg="5" class="mb-3">
              <b-button
                class="btn-gd text-left p-0 h-145px"
                :class="selectedAnswer == 4 ? 'selected' : ''"
                @click="buttonClicked(4)"
              >
                <div class="p-3">
                    <h6 class="h4 mb-0">2階の壁面に<br />取り付ける</h6>
                    <dl class="text-muted mb-0">
                      <dt>追加工事<br />高所作業費</dt>
                      <dd class="font-weight-bold h5 mb-0">
                        ¥<span class="h3 ml-1">11,000-</span>
                      </dd>
                    </dl>
                  </div>
              </b-button>
            </b-col>
            <b-col v-if="unitType === 2 || unitType === 3" cols="12" md="6" lg="5" class="mb-3">
              <b-button
                class="btn-gd text-left p-0 h-145px"
                :class="selectedAnswer == 5 ? 'selected' : ''"
                @click="buttonClicked(5)"
              >
                <div class="p-3">
                    <h6 class="h4 mb-0">3階の壁面に<br />取り付ける</h6>
                    <dl class="text-muted mb-0">
                      <dt>追加工事<br />高所作業費</dt>
                      <dd class="font-weight-bold h5 mb-0">
                        ¥<span class="h3 ml-1">27,500-</span>
                      </dd>
                    </dl>
                  </div>
              </b-button>
            </b-col>

          </b-row>
        </b-collapse>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import StepperCol from "../StepperCol";
import { mapState, mapActions } from "vuex";
import config from "../../const";

const titles = [
  "なし",
  "1階部分の屋根",
  "2階部分の屋根",
  "1階の壁面",
  "2階の壁面",
  "3階の壁面",
];

export default {
  components: {
    StepperCol,
  },
  data() {
    return {
      collapsed: false,
      shrinking: false,
      selectedAnswer: null,
      skipped: false,
    };
  },
  watch: {
    currentStep(val, old) { // eslint-disable-line
    },
    maxStep(val, old) { // eslint-disable-line
      if (val >= 13) {
        this.collapsed = true;
      }
    },
    unitType(val, old) {
      old; // eslint-disable-line
      if (val == 2 || val == 3 || val == 6 || val == 7) {
        this.skipped = false;
        this.shrinking = false;
        this.collapsed = true;
      } else {
        this.skipped = true;
        this.collapsed = false;
        this.shrinking = false;
        this.selectedAnswer = 0
      }
    },
  },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
      unitType() {
        return this.$store.getters.unitType;
      },
    }),
    isCollapsed: {
      get() {
        if (this.shrinking) {
          if (window.innerWidth < 576) {
            return false;
          } else {
            return true;
          }
        } else {
          return this.collapsed;
        }
      },
      set(value) { // eslint-disable-line
      },
    },
    selectedTitle() {
      if (this.selectedAnswer == null) {
        return "";
      }
      return titles[this.selectedAnswer];
    },
    selectedPrice() {
      if (this.selectedAnswer == null) {
        return "";
      }
      return config.PRICES['unitFloor'][this.selectedAnswer];
    },
  },
  methods: {
    reset() {
      this.shrinking = false;
      this.collapsed = false;
      this.selectedAnswer = null;
    },
    ...mapActions({
      doUpdateStep: "doUpdateStep",
      doSaveAnswer: "doSaveAnswer",
    }),
    buttonClicked(value) {
      this.selectedAnswer = value;
      this.doSaveAnswer({ keyword: 'unit_floor', answer: value });
      this.doUpdateStep(14);
      this.shrinking = true;
      if (this.$gtag) {
        console.log("google:室外機を取り付ける階は？");
        this.$gtag.event("入力", {
          event_category: "選択",
          event_label: "STEP12",
          value: "室外機を取り付ける階は？",
        });
      }
    },
  },
};
</script>